export const plannerPhases = [
  {
    number: '01',
    days: 'Days 1–7',
    eyebrow: 'Diagnose',
    title: 'Establish the baseline',
    description: 'Understand the visible reputation signal before deciding what to change.',
    tasks: [
      {
        id: 'claim-profiles',
        title: 'Confirm your core business profiles',
        detail: 'Verify your Google Business Profile, primary review profiles, website, and social links are accurate.',
      },
      {
        id: 'record-baseline',
        title: 'Record your starting position',
        detail: 'Capture your current rating, review count, recent review pace, and unanswered reviews.',
      },
      {
        id: 'compare-competitors',
        title: 'Compare three nearby competitors',
        detail: 'Note where they have stronger review volume, recency, responses, or visible customer proof.',
      },
    ],
  },
  {
    number: '02',
    days: 'Days 8–14',
    eyebrow: 'Interpret',
    title: 'Find the trust pattern',
    description: 'Turn customer language into a focused reputation priority.',
    tasks: [
      {
        id: 'identify-praise',
        title: 'Identify repeated praise',
        detail: 'List the three qualities customers mention most often when describing a good experience.',
      },
      {
        id: 'identify-friction',
        title: 'Identify recurring friction',
        detail: 'Look for repeated concerns, unanswered questions, or service expectations that need attention.',
      },
      {
        id: 'choose-priority',
        title: 'Choose one 30-day priority',
        detail: 'Select the clearest opportunity: review collection, response consistency, proof visibility, or issue resolution.',
      },
    ],
  },
  {
    number: '03',
    days: 'Days 15–21',
    eyebrow: 'Deploy',
    title: 'Put customer proof to work',
    description: 'Create a repeatable rhythm instead of relying on one-time reputation pushes.',
    tasks: [
      {
        id: 'request-reviews',
        title: 'Start a review-request rhythm',
        detail: 'Choose the right customer moment, responsible team member, and simple request process.',
      },
      {
        id: 'reply-reviews',
        title: 'Respond to priority reviews',
        detail: 'Prepare thoughtful replies for recent reviews, including clear escalation for sensitive feedback.',
      },
      {
        id: 'publish-proof',
        title: 'Publish one proof-led asset',
        detail: 'Turn an approved customer theme into a useful social post, FAQ, or website update.',
      },
    ],
  },
  {
    number: '04',
    days: 'Days 22–30',
    eyebrow: 'Improve',
    title: 'Measure and set the next action',
    description: 'Review what changed and establish the next practical operating cycle.',
    tasks: [
      {
        id: 'check-progress',
        title: 'Compare progress with the baseline',
        detail: 'Review new feedback, response coverage, review pace, and completed content.',
      },
      {
        id: 'resolve-issue',
        title: 'Close one trust gap',
        detail: 'Address one repeated concern through an operational fix, clearer expectation, or updated customer communication.',
      },
      {
        id: 'plan-next-cycle',
        title: 'Set the next 30-day action',
        detail: 'Keep what worked, remove unnecessary steps, and choose the next measurable reputation priority.',
      },
    ],
  },
];

export const plannerStorageKeys = {
  completed: 'repupgrade-30-day-planner-completed',
  priority: 'repupgrade-30-day-planner-priority',
};